import { render } from "./CoacheForm.vue?vue&type=template&id=18337440&scoped=true"
import script from "./CoacheForm.vue?vue&type=script&lang=js"
export * from "./CoacheForm.vue?vue&type=script&lang=js"

import "./CoacheForm.vue?vue&type=style&index=0&id=18337440&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18337440"]])

export default __exports__